module.exports = __webpack_public_path__ + "static/son-of-the-morning-star-a5b1b734a95f9f7e6cc9c8c87b358a50.jpg";